import { Component, Input } from '@angular/core';
import { Field } from '../../model/formBuilderInterface';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  standalone: true
})
export class LabelComponent {
  @Input() field: Field;
}
